<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        Analysis of several canned-food preparations for magnesium ion gave the following data:
      </p>

      <v-simple-table style="max-width: 513px">
        <thead>
          <tr>
            <td style="text-align: center; font-weight: bold">
              Sample Mean <stemble-latex content="$(\%~\ce{Mg^2+})$" />
            </td>
            <td style="text-align: center; font-weight: bold">Number of Trials</td>
            <td style="text-align: center; font-weight: bold">
              Deviation of Individual Results from Mean
            </td>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td style="text-align: center">4.07</td>
            <td style="text-align: center">4</td>
            <td style="text-align: center">0.12, 0.06, 0.05, 0.11</td>
          </tr>
          <tr>
            <td style="text-align: center">8.04</td>
            <td style="text-align: center">3</td>
            <td style="text-align: center">0.09, 0.08, 0.12</td>
          </tr>
          <tr>
            <td style="text-align: center">3.77</td>
            <td style="text-align: center">4</td>
            <td style="text-align: center">0.02, 0.15, 0.07, 0.010</td>
          </tr>
        </tbody>
      </v-simple-table>

      <p class="mb-3">
        a) For Sample 1 evaluate the
        <stemble-latex content="$80\%$" />
        confidence limit of the mean.
      </p>

      <calculation-input
        v-model="inputs.input1"
        class="mb-5"
        prepend-text="$80\%~\text{CL:}$"
        :disabled="!allowEditing"
      />

      <p class="mb-3">
        b) Calculate <stemble-latex content="$S_{pooled}$" /> from the whole set of data.
      </p>

      <calculation-input
        v-model="inputs.input2"
        prepend-text="$S_{pooled}:$"
        class="mb-2"
        :disabled="!allowEditing"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import StembleLatex from '@/tasks/components/StembleLatex';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';

export default {
  name: 'ChemUPEI2210A1Q5',
  components: {
    CalculationInput,
    StembleLatex,
    ChemicalLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        input1: null,
        input2: null,
      },
    };
  },
};
</script>
